// @ts-strict-ignore
import { useQuery } from '@tanstack/react-query';

import { ajaxFetch, buildURLParamsString } from '~/helpers/api';
import { routes } from '~/helpers/routes';
import type { Transaction } from '../transaction/history/types';

export const useDuplicatePii = ({ evaluationToken }) => useQuery({
  queryKey: ['pii-indicators', evaluationToken],
  queryFn: async () => ajaxFetch(
    routes.evaluations.piiIndicators(evaluationToken), { camelCase: true },
  ),
  initialData: {},
  enabled: Boolean(evaluationToken),
});

export const useTransactionDetail = ({
  entityId,
  entityToken,
  evaluationDate,
  transactionId,
}) => useQuery<unknown, unknown, Transaction>({
  queryKey: ['transaction-detail', transactionId],
  queryFn: async () => {
    const url = routes.transactions.detail;
    const params = buildURLParamsString({
      entity_id: entityId,
      entity_token: entityToken,
      evaluation_date: evaluationDate,
      transaction_id: transactionId,
    });

    const { data: result } = await ajaxFetch(`${url}${params}`);

    return result?.currentTransaction;
  },
  enabled: Boolean(transactionId),
});
